var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMarkerGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 2 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.2179 21.4203C12.0762 21.4203 11.9333 21.4203 11.7948 21.4203L8.40396 23.313C7.08396 22.869 5.85962 22.1798 4.79522 21.2817L4.78253 17.473C4.70741 17.3545 4.63653 17.235 4.57093 17.1123L1.19918 15.192C0.933606 13.8487 0.933606 12.4664 1.19918 11.1231L4.56776 9.20817C4.63653 9.0865 4.70741 8.96589 4.77935 8.8474L4.79628 5.03871C5.85971 4.138 7.08374 3.4463 8.40396 3L11.7895 4.89271C11.9312 4.89271 12.0741 4.89271 12.2127 4.89271L15.5982 3C16.9182 3.44402 18.1425 4.13318 19.2069 5.0313L19.2196 8.83999C19.2947 8.95849 19.3656 9.07804 19.4312 9.20076L22.8008 11.1199C23.0664 12.4632 23.0664 13.8456 22.8008 15.1889L19.4322 17.1038C19.3635 17.2255 19.2926 17.3461 19.2206 17.4646L19.2037 21.2733C18.141 22.1741 16.9177 22.8662 15.5982 23.313L12.2179 21.4203Z",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 14.7386V13.8295C13.7576 13.8295 15.182 12.6085 15.182 11.1023C15.182 9.59602 13.7576 8.375 12.0002 8.375C10.2428 8.375 8.81836 9.59602 8.81836 11.1023",
    stroke: "#575757",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.3749C12.502 18.3749 12.909 17.9679 12.909 17.4659C12.909 16.9638 12.502 16.5568 11.9999 16.5568C11.4978 16.5568 11.0908 16.9638 11.0908 17.4659C11.0908 17.9679 11.4978 18.3749 11.9999 18.3749Z",
    fill: "#575757"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkerGray);
export default __webpack_public_path__ + "static/media/question_marker_gray.32c063539b84a15a946137f97caafaa7.svg";
export { ForwardRef as ReactComponent };